import React, {useEffect} from "react";
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Routes,Route} from "react-router-dom";
import Header from "./Header/header.jsx";
import Main from './Main/main';
import Footer from './Footer/footer';
import Product from './Main.product/main.product';
// import Sofrim from "./Sofrim/sofrim.js";
import Sign from "./Sign/sign";
import Validusers from './Sign/validusers';
import Validmail from "./Sign/validmail";
import Login from "./Login/login";
// import ValidReactForum from "./Forum/validreactforum.js";
// import ValidForum from "./Forum/validforum.js";
import Forget from "./Forget/forget";
import Fixpassword from "./Fixpassword/fixpassword";
import Privat from "./Privat/privat";
import UpdateName from "./UpdateName/updatename.js";
import Fixupdatename from "./Fixupdatename/fixupdatename.js";
import Create from "./Create/create";
import Validimg from "./Create/validimg";
import Testimg from "./Create/testimg";
import Delete from "./Delete/delete";
import Takanon from "./Takanon/takanon";
import False from './404/404';
function App() {
  const location = useLocation();
  const state = location.state;
  useEffect(()=>{
    window.scrollTo({
      top:0
    })
},[state]); 
  return (
    <div className="App" dir="rtl">
    <header className="App-header">
         <Header/>
       </header>
       <main>
            <Routes >
               <Route path="/" element={<Main />}/>
              
              <Route path="/product" element={<Product/>}/>
              {/* <Route path="/sofrim" element={ <Sofrim/>}/>  */}
              <Route path="/sign" element={ <Sign/>}/> 
              <Route path="/validusers" element={ <Validusers/>}/> 
              <Route path="/validmail" element={ <Validmail/>}/> 
              <Route path="/login" element={ <Login/>}/> 
              {/* <Route path="/validreactforum" element={ <ValidReactForum/>}/> 
              <Route path="/validforum" element={ <ValidForum/>}/>  */}
             <Route path="/privat" element={ <Privat/>}/>
              <Route path="/create" element={ <Create/>}/> 
              <Route path="/testimg" element={ <Testimg/>}/> 
              <Route path="/validimg" element={ <Validimg/>}/> 
              <Route path="/delete" element={ <Delete/>}/> 
              <Route path="/forget" element={ <Forget/>}/> 
              <Route path="/updatename" element={ <UpdateName/>}/> 
              <Route path="/fixupdatename" element={ <Fixupdatename/>}/> 
              <Route path="/fixpassword" element={ <Fixpassword/>}/> 
              <Route path="/takanon" element={ <Takanon/>}/> 
              <Route path="*" element={ <False/>}/>
            </Routes> 
      </main>
     <footer>
        <Footer/>
      </footer>    
    </div>
  );
}

export default App;
